
import request from '@/util/http'



// 建议列表查询
export const getAdvicePage=(params)=>request({
    url: '/admin/advice/page',
    method: 'get',
    params
})

// 删除建议
export const handleAdviceDelete=(id)=>request({
    url: `/admin/advice/delete/${id}`,
    method: 'delete'
})
// 建议详情
export const getAdviceInfo=(id)=>request({
    url: `/admin/advice/get/${id}`,
    method: 'get'
})

// 新增建议
export const adviceAdd=(data)=>request({
    headers:{
        "Content-Type": "application/json"
    },
    url: `/admin/advice/save`,
    method: 'post',
    data:JSON.stringify(data)
})

// 回复建议
export const adviceEdit=(data)=>request({
    headers:{
        "Content-Type": "application/json"
    },
    url: `/admin/advice/update`,
    method: 'post',
    data:JSON.stringify(data)
})
//--------------------------------------------------------------------------

// 留言列表查询
export const getServeLeaveMessagePage=(params)=>request({
    url: '/admin/serveLeaveMessage/page',
    method: 'get',
    params
})

// 删除留言
export const handleServeLeaveMessageDelete=(id)=>request({
    url: `/admin/serveLeaveMessage/delete/${id}`,
    method: 'delete'
})

// 留言详情
export const getServeLeaveMessageInfo=(id)=>request({
    url: `/admin/serveLeaveMessage/get/${id}`,
    method: 'get'
})

// 新增或者修改留言
export const serveLeaveMessageAddAndEdit=(data)=>request({
    headers:{
        "Content-Type": "application/json"
    },
    url: `/admin/serveLeaveMessage/saveOrUpdate`,
    method: 'post',
    data:JSON.stringify(data)
})


//--------------------------------------------------------------------------


// 删除留言回复
export const handleMessageAnswerDelete=(id)=>request({
    url: `/admin/messageAnswer/delete/${id}`,
    method: 'delete'
})
//新增或者修改留言回复
export const messageAnswerAddAndEdit=(data)=>request({
    headers:{
        "Content-Type": "application/json"
    },
    url: `/admin/messageAnswer/save`,
    method: 'post',
    data:JSON.stringify(data)
})
